module.exports = __webpack_public_path__ + "static/firebase-logo-92972636c7f06706cacc24a80234ecf3.svg";